var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-5" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticStyle: { overflow: "auto" } },
              [
                _vm.activateSpinner
                  ? _c("spinner")
                  : _vm.listItemsEntityAccount.length > 0
                  ? _c("b-table", {
                      key: _vm.refreshKey,
                      staticClass: "table-striped",
                      staticStyle: { "margin-bottom": "0" },
                      attrs: {
                        items: _vm.listItemsEntityAccount,
                        fields: _vm.fields,
                        hover: "",
                        "empty-text": _vm.$t("common.security.no_result"),
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDir,
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function ($event) {
                          _vm.sortDir = $event
                        },
                        "update:sort-desc": function ($event) {
                          _vm.sortDir = $event
                        },
                        "head-clicked": _vm.sortTable,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(StatusImportIban)",
                          fn: function (data) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.entity_account.iban_import_status_" +
                                        data.value
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              data.item.ProviderRejectionReason
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "text-truncate",
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        title:
                                          data.item.ProviderRejectionReason,
                                      },
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "common.entity_account.reason"
                                            )
                                          ) + " : "
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            data.item.ProviderRejectionReason
                                              .length > 15
                                              ? data.item.ProviderRejectionReason.substring(
                                                  0,
                                                  15
                                                ) + "..."
                                              : data.item
                                                  .ProviderRejectionReason
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "cell(FileReference)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(DateAction)",
                          fn: function (data) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getDate(data.value))),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(Iban)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(IbanReference)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                      ]),
                    })
                  : _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("span", { staticClass: "noResult" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.no_result")) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }